package kz.dentalcrm.app.expectations

import androidx.compose.runtime.Composable
import androidx.compose.runtime.State
import androidx.compose.runtime.remember

interface ContactPickerState {
    val value: State<UserPhone?>

    @Composable
    fun initContactPicker()

    fun launchContactPicker()
}


@Composable
fun rememberContactPickerState(
    contactPicked: (UserPhone?) -> Unit,
): ContactPickerState {
    return rememberMutableContactPickerState(contactPicked).also {
        it.initContactPicker()
    }
}


@Composable
private fun rememberMutableContactPickerState(contactPicked: (UserPhone?) -> Unit): ContactPickerState {
    return remember { ContactPickerStateImpl(contactPicked) }
}